import { useGetDocumentContractFilterDimensions } from "hooks/api/documents/documentFilterDimensions";
import useSelectedCustomerCode from "hooks/useSelectedCustomerCode";
import { removeNullable } from "services/apiHelpers";
import {
  CheckboxListFilter,
  FilterOption,
} from "../GenericFilters/CheckboxListFilter";
import { FilterProps } from "../filter-definition";

export const ContractsStatusFilter = ({ variant }: FilterProps) => {
  const cardCodes = useSelectedCustomerCode();

  const { data, isLoading } = useGetDocumentContractFilterDimensions(cardCodes);

  const statusOptions: FilterOption[] = removeNullable(
    data?.documentStatuses?.map((status) => ({
      label: status.Name,
      value: status.Code,
    })) ?? []
  ).reverse();

  return (
    <CheckboxListFilter
      filterKey="status"
      name="Status"
      variant={variant}
      filterOptions={statusOptions}
      isLoading={isLoading}
    />
  );
};
